import { Chart as BaseChart } from "@primayer/prime-google-map";

export default class Chart extends BaseChart {
  constructor(chartObj) {
    super(chartObj);

    this.baseChartOptions = {
      height: 150,
      borderWidth: 2,
      backgroundColor: "#00000000",
      borderColor: "#005387"
    };
  }

  get colour() {
    var confidence = this.confidence,
      colour = "#4287D4";

    if (confidence >= 50 && confidence < 80) {
      colour = "#ff8547"; //#ff8547
    }
    if (confidence >= 80) {
      colour = "#e74139";
    }
    return colour;
  }
}
